import * as React from "react";
import type { SVGProps } from "react";
const SvgCirclepromptIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="circleprompt_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768zM42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512 771.2 981.333 512 981.333 42.667 771.2 42.667 512zm426.666 170.667A42.667 42.667 0 0 1 512 640h.427a42.667 42.667 0 1 1 0 85.333H512a42.667 42.667 0 0 1-42.667-42.666zm85.334-341.334a42.667 42.667 0 1 0-85.334 0V512a42.667 42.667 0 1 0 85.334 0V341.333z"
    />
  </svg>
);
export default SvgCirclepromptIcon;
